import React from "react";
import PropTypes from "prop-types";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import IconButton from "material-ui/IconButton";
import ExpandLess from "material-ui-icons/ExpandLess";
import Menu from "material-ui-icons/Menu";
import Info from "material-ui-icons/InfoOutline";
import { resetResults, switchMenuState } from "../../../modules/search";
import "./HeaderCard.css";
import logoIcon from "../../../icons/logo.svg";

const HeaderCard = props => (
  <div className={props.isCity ? "city-header headerCard" : "headerCard"}>
    <div className="top-header-container">
      <div
        tabIndex={0}
        onClick={() => {
          props.resetResults();
          props.goRoot();
        }}
        onKeyPress={() => {
          props.resetResults();
          props.goRoot();
        }}
        role="button"
        className="title-header"
      >
        <img alt="logo" src={logoIcon} />
      </div>
      <a href="/fr/apropos/" title="Informations">
        <IconButton
          style={{ height: "35px" }}
          color="contrast"
          aria-label="Informations"
          onClick={props.openInfoDialog}
        >
          <Info />
        </IconButton>
      </a>
    </div>
    <div className="sub-header-container">
      <div className="subtitle">{props.subtitle}</div>
      <div className="icon-menu-container">
        <IconButton
          onClick={() => props.switchMenuState()}
          color="contrast"
          aria-label="ExpandLess"
        >
          {props.menuIsOpen ? <ExpandLess /> : <Menu />}
        </IconButton>
      </div>
    </div>
  </div>
);

HeaderCard.propTypes = {
  subtitle: PropTypes.string.isRequired,
  isCity: PropTypes.bool.isRequired,
  goRoot: PropTypes.func.isRequired,
  resetResults: PropTypes.func.isRequired,
  switchMenuState: PropTypes.func.isRequired,
  menuIsOpen: PropTypes.bool.isRequired,
  openInfoDialog: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  menuIsOpen: state.search.menuIsOpen
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      goRoot: () => push(`/`),
      resetResults,
      switchMenuState
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HeaderCard);



// WEBPACK FOOTER //
// ./src/containers/MainCard/HeaderCard/HeaderCard.jsx